export default "__VITE_ASSET__23a5b529__"